<template>
  <div style="background:#FAFAFA;" class="policeLato">
    <div>
      <div class="container mt-5 pt-5" style="background:#FAFAFA">
        <!-- <div class="container justify-content-center row text-center mb-5 mt-5">
          <p class="mb-3" style="font-weight: 300;color: red;font-family: Open Sans, sans-serif;font-size:25px!important;">
            <span><v-icon class="mr-1" color="red">&#xe15e;</v-icon></span>
            <span style="padding-top: 2px">{{ $t('contrat.payment_failed.title') }}</span>
          </p>
        </div> -->

        <!-- ===================  DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      ================= -->
        <!-- =                    SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                    = -->
        <!-- =                    DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE                 = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl class="mt-5 row" style="background:#FAFAFA;padding-top: 40px!important">
          <div class="col-md-10 offset-1" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="page mb-5">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <div class="row justify-content-center" style="width: -webkit-fill-available;">
                            <div class="message-box _success _failed">
                              <div class="justify-content-center row">
                                <div class="justify-center d-flex align-items-center" style="background-color: #FAFAFA; top: 0; width: 150px; height: 50px; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px; margin-top: -45px;">
                                <img src="../assets//img/assuraf_lg.png" width="80" alt="logo assuraf">
                                </div>
                              </div>
                              <i class="mt-3 fa fa-thumbs-down" aria-hidden="true"></i>
                                <h2 style="color: red">{{ $t('contrat.payment_failed.title') }}</h2>
                                <p>{{ $t('contrat.payment_failed.content[0]') }}<br>
                                  {{ $t('contrat.payment_failed.content[1]') }}<br>{{ $t('contrat.payment_contrat.thank_you_message[2]') }}<br><br>
                                  </p> 
                                  <p><span class="ml-3"><a v-if="returnButtonToPayement" class="mr-5 font-weight-bold" style="color: #454C53;" href="javascript:void(0)" @click="$router.go(-2)"><i style="font-size: 15px;color: #454C53!important;" class="fa fa-arrow-left" aria-hidden="true"></i> {{ $t('contrat.payment_failed.bouton_retour_label') }}</a> <a class="font-weight-bold" style="color: #ffa409;" href="javascript:void(0)" @click="assistanceDialogManip()">{{ $t('contrat.payment_failed.bouton_assistance_label') }}</a></span></p>
                                  

                                  
                                  <div class="row mt-5 justify-content-between" style="margin-bottom: -40px;">
                                    <div class="col-md-6">
                                    </div>

                                    <div class="col-md-6 text-right">
                                      <div class="mt-2 justify-content-end row">
                                        <p style="margin-top: 5px!important;">{{ $t('contrat.payment_contrat.text_to_whatsapp_label') }} </p>
                                        <a href="whatsapp://send?phone=+221761416464&text=Hello Assuraf 👋" target="_blank" rel="nofollow noopener noreferrer">
                                          <img class="ml-3" src="../assets/img/thankPagesSocialIcon/whatsapp_grey.png" width="30" alt="grey whatsapp logo" style="margin-top:1px">
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                            </div> 

                            <!-- <div class="row justify-content-center">
            <div class="col-md-5">
                <div class="message-box _success _failed">
                     <i class="fa fa-times-circle" aria-hidden="true"></i>
                    <h2> Your payment failed </h2>
             <p>  Try again later </p> 
         
            </div> 
        </div> 
    </div>  -->
                        </div> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===================  DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE       ================= -->
        <!-- =                    SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                    = -->
        <!-- =                    DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE                 = -->
        <!-- ========================================================================================= -->
        <div v-responsive.sm.xs class="mt-5 row" style="background:#FAFAFA;padding-top: 40px;important">
          <div class="col-md-10" style="background:#fafafa">
            <div class="form" style="background:#FAFAFA">
              <div class="page mb-5">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <div class="row justify-content-center" style="width: -webkit-fill-available;">
                            <div class="message-box _success _failed">
                              <div class="justify-content-center row">
                                <div class="justify-center d-flex align-items-center" style="background-color: #FAFAFA; top: 0; width: 150px; height: 50px; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px; margin-top: -45px;">
                                <img src="../assets//img/assuraf_lg.png" width="80" alt="logo assuraf">
                                </div>
                              </div>
                                <i class="fa fa-thumbs-down mt-5" aria-hidden="true"></i>
                                <h2 style="color: red">{{ $t('contrat.payment_failed.title') }}</h2>
                                <p>{{ $t('contrat.payment_failed.content[0]') }}<br>
                                  {{ $t('contrat.payment_failed.content[1]') }}<br>{{ $t('contrat.payment_contrat.thank_you_message[2]') }}<br><br>
                                  </p> 
                                  <p class="mt-2">
                                     <span><a class="font-weight-bold" style="color: #ffa409;" href="javascript:void(0)" @click="assistanceDialogManip()">{{ $t('contrat.payment_failed.bouton_assistance_label') }}</a></span></p>
                                     <p class="mt-2" v-if="returnButtonToPayement">
                                      <span><a class="font-weight-bold" style="color: #454C53;" href="javascript:void(0)" @click="$router.go(-2)"><i style="font-size: 15px;color: #454C53!important;" class="fa fa-arrow-left" aria-hidden="true"></i> {{ $t('contrat.payment_failed.bouton_retour_label') }}</a></span></p>
                                  
                                  <div class="justify-content-center row">
                                    <p style="margin-top: 15px;">{{ $t('contrat.payment_contrat.text_to_whatsapp_label') }} </p>
                                  </div> 
                                  <div class="mt-2 justify-content-center row" style="margin-bottom: -30px;">
                                    <a href="whatsapp://send?phone=+221761416464&text=Hello Assuraf 👋" target="_blank" rel="nofollow noopener noreferrer">
                                          <img class="ml-3" src="../assets/img/thankPagesSocialIcon/whatsapp_grey.png" alt="grey whatsapp logo" width="30" style="margin-top:1px">
                                        </a>
                                </div>
                            </div> 
                        </div>    
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- popup pour demande d'assistance -->
        <!-- popup pour demande d'assistance -->
        <v-dialog v-model="assistanceDialog" max-width="800">
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="infosAssistance" aria-hidden="true" aria-labelledby="step-infosAssistance" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('list_devis.assistance_form.assistance_title') }}</div>
                        <div class="row">
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="HoraireRappel" class="field-label">{{ $t('list_devis.assistance_form.horaire_rappel_label') }}</label>
                              <select id="HoraireRappel" name="infosAssis" class="field-select" v-model="horaire">
                                <option v-for="itm in itema" :key="itm" :value="itm">{{itm}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="CanalRappel" class="field-label">{{ $t('list_devis.assistance_form.canal_rappel_label') }}</label>
                              <select id="CanalRappel" name="infosAssis" class="field-select" v-model="canal">
                                <option v-for="itm in rappel" :key="itm" :value="itm">{{itm}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="nom" class="field-label">{{ $t('list_devis.assistance_form.nom_label') }}</label>
                              <input v-model="name" :placeholder="$t('list_devis.assistance_form.nom_placeholder')" id="nom" name="infosAssis" class="field-input">
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-4">
                            <div class="field-group field-default">
                              <label for="num" class="field-label">
                                {{ $t('list_devis.assistance_form.telephone_label') }}
                              </label>
                              <div class="input-group value-loan">
                                <input :placeholder="$t('list_devis.assistance_form.telephone_placeholder')" v-model="tel" id="num" name="infosAssis" class="field-input">
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default">
                              <label for="Object" class="field-label">
                                {{ $t('list_devis.assistance_form.objet_label') }}
                              </label>
                              <div class="input-group value-loan">
                                <input :placeholder="$t('list_devis.assistance_form.objet_placeholder')" v-model="objetRappel" id="Object" name="infosAssis" disabled class="field-input">
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default">
                              <label for="Remarque" class="field-label">
                                {{ $t('list_devis.assistance_form.remarque_label') }}
                              </label>
                              <div class="input-group value-loan">
                                <textarea rows="4" cols="50" :placeholder="$t('list_devis.assistance_form.remarque_placeholder')" v-model="remarques" id="Remarque" name="infosAssis" class="field-input"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="assistanceDialog = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('list_devis.assistance_form.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button @click="AddAssistance()" type="button" class="wizard-btn">
                    {{ $t('list_devis.assistance_form.bouton_valider_label') }}
                  </button>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>

    <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
    <login-form :visible="showLoginForm" @close="showLoginForm=false"></login-form>
  </div>
</template>


<script>
    import Api from '../services/Api'
    import {mapGetters} from 'vuex'
    import store from "../store/store";
    import LoginForm from "@/components/auth/Login";

    export default {
        name: 'payement_failed',
        components: {
          LoginForm
        },
        data() {
            return {
                returnButtonToPayement : false,
                showLoginForm: false,
                assistanceDialog: false,
                ToastTabSucess: {
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 5000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                }, // Customized options for success toast
                ToastTabError: {
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 5000,
                    fitToScreen: true,
                    type: 'error'
                },// Customized options for error toast
                itema: ['Le plus tôt possible', 'Dans la matinée', 'Dans la journée'],
                rappel: ['Whatsapp', 'Appel', 'Email'],
                objet: ['Devis', 'Souscription', 'Contrat', 'Paiement', 'Conseil', 'Sinistre', 'Autres'],
                horaire: null,
                canal: null,
                name: '',
                tel: '',
                objetRappel: null,
                remarques: null,
                timer: '',
                ExitByUser: true
            }
        },
        methods: {
            sendmailAdmin: function () {
                let amount = localStorage.getItem('amount')
                let numdevis = localStorage.getItem('numdevis')
                let canal = localStorage.getItem('canal')
                const body = {
                    sender_email: "Assuraf Logs " + canal,
                    sujet: "Echec de Paiement de contrat ",
                    message: "Paiement de " + amount + " FCFA à assuraf.com n'a pas été validé par \n " + "Nom et Prenom : " + this.$store.state.user.nom + " " + this.$store.state.user.prenom + "\n N° devis : " + numdevis + "\n" + "Date :" + Date()
                }
                Api().post('messaegeadmin/sendMail', body)
                    .then(res => {
                            localStorage.removeItem('canal');
                            localStorage.removeItem('numdevis');
                            localStorage.removeItem('amount')
                            localStorage.removeItem('adressliv')
                            localStorage.removeItem('Callback')

                            localStorage.removeItem('loic')
                            localStorage.removeItem('papa')
                            localStorage.removeItem('UserArray')
                            localStorage.removeItem('PaymentlinkId')

                            localStorage.removeItem('InercomName');
                            localStorage.removeItem('InercomEmail');
                            localStorage.removeItem('InercomPhone');
                            localStorage.removeItem('seturlapi');

                        }
                    )
                    .catch(err => {
                            localStorage.removeItem('canal');
                            localStorage.removeItem('numdevis');
                            localStorage.removeItem('amount')
                            localStorage.removeItem('adressliv')
                            localStorage.removeItem('Callback')

                            localStorage.removeItem('loic')
                            localStorage.removeItem('papa')
                            localStorage.removeItem('UserArray')
                            localStorage.removeItem('PaymentlinkId')

                            localStorage.removeItem('InercomName');
                            localStorage.removeItem('InercomEmail');
                            localStorage.removeItem('InercomPhone');
                            localStorage.removeItem('seturlapi');

                        }
                    )
            },
            returnToPaiementManip() {
            if(this.$store.state.isUserLoggedIn==true)
            {
              this.returnButtonToPayement = true
            }else {
              this.returnButtonToPayement = false
            }
          },

            assistanceDialogManip() {
              if(this.$store.state.isUserLoggedIn==true)
              {
                this.objetRappel = 'Paiement';
                this.name = store.state.user.prenom.toUpperCase() + '-' + store.state.user.nom.toUpperCase();
                this.tel = store.state.user.telephone_port;
                this.assistanceDialog = true
              }else {
                this.showLoginForm = true
              }
            },

            /* Retourne true ou false si nous sommes sur un PC */
            isDesktop: function () {
                if (screen.width > 760) {
                    return true;
                } else {
                    return false;
                }
            },

            /* Retourne true ou false si nous sommes sur un mobile */
            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },

            AddAssistance() {
                if (this.horaire && this.canal && this.name && this.tel && this.objetRappel && this.remarques) {
                    const assist = {
                        horaire: this.horaire,
                        canal: this.canal,
                        name: this.name,
                        tel: this.tel,
                        objetRappel: this.objetRappel,
                        remarques: this.remarques,
                        userid: store.state.user._id
                    };

                    Api().post('assistances/create', assist)
                        .then(resp => {
                            if (resp.data.info == 'ok') {
                                this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                                this.assistanceDialog = false;
                                this.horaire = '';
                                this.canal = '';
                                this.name = '';
                                this.tel = '';
                                this.objetRappel = '';
                                this.remarques = ''
                            } else if (resp.data.info == 'nok') {
                                this.$toasted.show(resp.data.msg, this.ToastTabError)
                            }

                        })

                } else {
                    this.$toasted.show("Tous les champs sont obligatoires !", this.ToastTabError)
                }
            }
        },
        computed: {
            ...mapGetters([
                'username'
            ])
        },

        mounted() {
          window.scrollTo(0, 0);
          this.returnToPaiementManip()
          this.sendmailAdmin()
          if (!this.$store.state.user) {
            this.$router.push('/')
          }
        }
    }
</script>

<style lang="less" scoped>
@import "../assets/css/button.css";
@import "../assets/css/devis_css.css";
@import "../assets/css/assurcare/form_assurcare.css";


.to-left {
  text-align: left;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}
.form {
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 15px!important;
}

.form .page {
  height: auto;
}

button.next {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 1.5rem;
  margin-bottom: 1rem;
}

button.previous {
  position: absolute;
  bottom: 0;
  left: 0;
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}


button.edit {
  position: absolute;
  bottom: 0;
  right: 0;
}

h4 {
  color: #29323a;
  margin-bottom: 15px;
  font-weight: 600;
}

html {
  background-color: #1a1a1a;
  overflow: hidden;
}

.row-container {
    background: white;
}

.border-radius {
    border-radius: 20px;
}

.georgia {
    font-family: Georgia !important;
}



._failed{ border-bottom: solid 4px red !important; }
._failed i{  color:#ffa409 !important;  }

._success {
  background-color: rgb(255, 251, 246);;
    border-radius: 10px;
    box-shadow: 0 15px 25px #00000019;
    padding: 45px;
    width: 100%;
    text-align: center;
    margin: 40px auto;
    // border-bottom: solid 4px #28a745;
    border-bottom: solid 4px #ffa409;
}

._success i {
    font-size: 55px;
    color: #28a745;
}

._success h2 {
    margin-bottom: 12px;
    font-size: 30px;
    font-weight: 500;
    line-height: 1.2;
    margin-top: 10px;
}

._success p {
    margin-bottom: 0px;
    font-size: 15px;
    color: #000;
    font-weight: 500;
}

.attestation-content {
    border: 1px solid;
    padding: 15px;
    border-radius: 10px;
    background: #fff;
}
</style>
